import {ComponentProps, useMemo} from 'react';
import {SetOptional} from 'type-fest';

import {RadioGroupItemConfig, FilterDialogItemType} from 'filters/features/FilterDialog/types';

import {useIsDownMd} from 'utils/hooks/useMediaQuery';
import {openFilterDialog} from 'filters/features/FilterDialog/emitter';
import {useEditedFilterContext} from 'filters/features/FilterDialog/contexts/internal/EditedFilterProvider/EditedFilterProvider';

import {RadioGroup} from 'components/RadioGroup';

import {Block} from 'filters/features/FilterDialog/components/Block';

export const createRadioGroupItem = <T,>(config: SetOptional<RadioGroupItemConfig<T>, 'getActiveFiltersContent'>) => {
  return {
    getActiveFiltersContent: ({value}, {sectionId}) => {
      const option = config.options.find(option => option.value === value);

      return option
        ? {
            id: config.id,
            label: config.label,
            chips: [
              {
                id: option.value as string,
                label: option.label,
                onClick: () => openFilterDialog(sectionId),
              },
            ],
          }
        : null;
    },
    ...config,
    type: FilterDialogItemType.RadioGroup,
  } satisfies ComponentProps<typeof RadioGroupItem> & {
    type: FilterDialogItemType.RadioGroup;
  };
};

export const RadioGroupItem = ({getValue, label, options, onChange}: RadioGroupItemConfig<any>) => {
  const {filter, setFilter} = useEditedFilterContext();
  const value = getValue(filter);

  const isDownMd = useIsDownMd();

  const option = useMemo(() => options.find(option => option.value === value), [value, options]);

  return (
    <Block label={label} helperText={option?.annotation}>
      <RadioGroup
        row={!isDownMd}
        options={options}
        value={option?.value}
        onChange={(_, value) => setFilter(prev => onChange(prev, value))}
      />
    </Block>
  );
};
